export class CostReviewContractualDocumentation {
  isContractualDocumentationApplicableLessThanThreshold!: boolean;
  isContractualDocumentationApplicable!: boolean;
  originalCompletionDate!: Date;
  siemensTermsConditionsUsed!: number;
  warrantyPeriod!: number;
  liquidatedDamagesLiability!: number;
  consequentialDamagesInContract!: number;
  waiverReason!: number;
  fireStopping!: number;
  patchingPainting!: number;
  demolitionRemoval!: number;
  cleanUp!: number;
  possibleChangeOrdersIdentified!: string;
  performanceBondAmount!: number;
  paymentBondAmount!: number;
  penetrationRequirements!: number[];
  trainingSpecified!: number;
  changeOrderMarkupRestrictions!: number;
  changeOrderOpportunities!: string;
  specialInsuranceCertification!: number;
  liabilityInsurance!: number;
  deductionsOffered!: number;
  testingPeriod!: number;
  testingFromDate!: Date | null;
  testingToDate!: Date | null;
  licensesPermits!: number;
  specialSafetyRequirements!: string;
}
